import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=a890439e"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports